const createSearchItem = ({
  id,
  name,
  name_tr,
  url,
  category = 'Admin',
  category_tr = 'Admin',
}) => ({
  id,
  name,
  name_tr,
  category,
  category_tr,
  searchText: `${name}|${category}`,
  searchText_tr: `${name_tr}|${category_tr}`,
  url,
});

const searchItems = [
  {
    id: 'admin-1',
    name: 'Permission Group Management',
    name_tr: 'Yetki Grubu Yönetimi',
    url: '/admin/management-role',
  },
  {
    id: 'admin-2',
    name: 'Permission Management',
    name_tr: 'Yetki Yönetimi',
    url: '/admin/management-operation',
  },
  {
    id: 'admin-3',
    name: 'Permission Group - Permission Mapping',
    name_tr: 'Yetki Grubu - Yetki Eşleştirme',
    url: '/admin/management-role-operation-connect',
  },
  {
    id: 'admin-4',
    name: 'Role - Permission Group Mapping',
    name_tr: 'Rol-Yetki Grubu Eşleştirme',
    url: '/admin/management-user-type',
  },
  {
    id: 'admin-5',
    name: 'Bank Information Management',
    name_tr: 'Banka Bilgileri Yönetimi',
    url: '/admin/management-banks',
  },
  {
    id: 'admin-6',
    name: 'User Management',
    name_tr: 'Kullanıcı Yönetimi',
    url: '/admin/management-user',
  },
  {
    id: 'admin-7',
    name: 'Card Images Management',
    name_tr: 'Kart Görselleri Yönetimi',
    url: '/admin/management-card-image',
  },
  {
    id: 'admin-8',
    name: 'Customer Special Authorization',
    name_tr: 'Müşteri Özel Yetki',
    url: '/admin/customer-authorization',
  },
  {
    id: 'admin-9',
    name: 'Banner/Widget Listing',
    name_tr: 'Banner/Widget Listeleme',
    url: '/admin/management-widget',
  },
  {
    id: 'admin-10',
    name: 'Language Management',
    name_tr: 'Dil Yönetimi',
    url: '/admin/management-language',
  },
  {
    id: 'admin-11',
    name: 'Fast Access Menu Management',
    name_tr: 'Hızlı Erişim Menüsü Yönetimi',
    url: '/admin/management-fast-access-menu',
  },
  {
    id: 'admin-12',
    name: 'Parameter Management',
    name_tr: 'Parametre Yönetimi',
    url: '/admin/management-app-settings',
  },
  {
    id: 'admin-13',
    name: 'Search Bar Management',
    name_tr: 'Search Bar Yönetimi',
    url: '/admin/management-search-bar',
  },
].map(createSearchItem);

export default searchItems;